<template>
    <v-dialog v-model="handleDialog" width="1400" class="common-dialog" persistent>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <form @submit.prevent="pushOk">
                <v-card color="#F4FEFB">
                    <v-card-title class="justify-center">
                        <h2 v-if="id">署名者編集</h2><h2 v-else>署名者追加</h2>
                    </v-card-title>
                    <v-card-text class="common-dialog-message display-flex">
                        <v-container style="width:50%; max-width:50%;">
                            <v-row>
                                <v-col cols="12" xl="4">
                                    <badge-component tile color="red" content="必　須">
                                        <label-component>氏名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="required|max:100" name="destination_user_name" v-slot="{ errors }">
                                        <v-text-field outlined clearable v-disabled-icon-focus required v-model="destination_user_name" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile color="red" content="必　須">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="required|email|max:255" name="destination_email_address" v-slot="{ errors }">
                                        <v-text-field required outlined clearable v-disabled-icon-focus v-model="destination_email_address" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>会社名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider v-slot="{ errors }" name="destination_company_name" rules="max:50" >
                                        <v-text-field outlined clearable v-disabled-icon-focus v-model="destination_company_name" :error-messages="errors" autocomplete="new-name" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="4">
                                    <badge-component tile content="任　意">
                                        <label-component>アクセスコード</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider v-slot="{ errors }" name="アクセスコード" rules="max:255|alpha_num_symbol:access_code_raw" >
                                        <!-- autocomplate対策ダミー -->
                                        <input type="email" name="hidden" id="hidden1" style="width: 0; height: 0; border: 0; padding: 0; top:-100px; position: fixed;" tabindex="-1" />
                                        <input type="password" name="hidden" id="hidden2" style="width: 0; height: 0; border: 0; padding: 0; top:-100px; position: fixed;" tabindex="-1" />
                                        <input style="visibility: hidden; top:-100px; position: fixed;" type="text" tabindex="-1" />
                                        <input style="visibility: hidden; top:-100px; position: fixed;" type="password" tabindex="-1" />
                                        <v-text-field outlined clearable v-disabled-icon-focus name="access_code" v-model="access_code" :error-messages="errors" ref="accessCodeInput"
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show1 = !show1"
                                            autocomplete="new-password"
                                            oncopy="return false" onpaste="return false" oncontextmenu="return false"
                                            v-if="!reRendorFlag"
                                            background-color="white"
                                        ></v-text-field>
                                    </validation-provider>
                                    <validation-provider name="access_code_raw">
                                        <v-text-field 
                                            v-model="item.access_code"
                                            readonly
                                            oncopy="return false" 
                                            onpaste="return false" 
                                            oncontextmenu="return false"
                                            style="visibility: hidden; top:-100px; position: fixed;"
                                        ></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container style="width:50%; max-width:50%;">
                            <v-tabs grow>
                              <v-tab active-class="white">契約先メンバー</v-tab>
                              <v-tab-item>
                                <v-card>
                                  <v-card-text>
                                    <v-container class="search-container">
                                        <v-row style="height:80px;">
                                            <v-col class="display-flex">
                                                <v-text-field
                                                v-model="destination_search_name"
                                                append-icon="mdi-magnify"
                                                :height="20"
                                                placeholder="氏名・会社名・メールアドレスでの検索"
                                                outlined
                                                background-color="white"
                                                dense
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="destination-member-area">
                                                <table class="destination-member-table">
                                                    <tbody>
                                                        <tr 
                                                            v-for="destinationUserRecord in filterDestinationRecords" 
                                                            :key="destinationUserRecord.index" 
                                                            @click="selected_reflect(destinationUserRecord)"
                                                        >
                                                            <td>
                                                                {{ destinationUserRecord.company }}
                                                            </td>
                                                            <td>
                                                                {{ destinationUserRecord.name }}
                                                            </td>
                                                            <td style="display:none">
                                                                {{ destinationUserRecord.email }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                  </v-card-text>
                                </v-card>
                              </v-tab-item>
                              
                              <v-tab  active-class="white">社内メンバー</v-tab>
                              <v-tab-item>
                                <v-card>
                                  <v-card-text>
                                    <v-container class="search-container">
                                        <v-row 
                                            style="height:80px;">
                                            <v-col class="display-flex">
                                                <v-text-field
                                                v-model="user_search_name"
                                                append-icon="mdi-magnify"
                                                :height="20"
                                                placeholder="氏名での検索(部分一致)"
                                                outlined
                                                dense
                                                background-color="white"
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="member-area">
                                                <table class="membertable"><tbody>
                                                    <tr class="membertable-row" v-for="userRecord in filterUserRecords" :key="userRecord.index" @click="selected_user_reflect(userRecord)">
                                                        <td class="membertable-name">{{ userRecord.name }}</td>
                                                        <td>{{ userRecord.email }}</td>
                                                        <td class="membertable-company">{{ userRecord.company }}</td>
                                                    </tr>
                                                </tbody></table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    
                                  </v-card-text>
                                </v-card>
                              </v-tab-item>

                              <v-tab  active-class="white">送信履歴</v-tab>
                              <v-tab-item>
                                <v-card>
                                  <v-card-text>
                                    <v-container class="search-container">
                                        <v-row style="height:80px;">
                                            <v-col class="display-flex">
                                                <v-text-field
                                                v-model="history_search_name"
                                                append-icon="mdi-magnify"
                                                :height="20"
                                                placeholder="氏名・会社名・メールアドレスでの検索"
                                                outlined
                                                background-color="white"
                                                dense
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="member-area">
                                                <table class="membertable"><tbody>
                                                    <tr class="membertable-row" v-for="userRecord in filterHistoryRecords" :key="userRecord.index" @click="selected_user_reflect(userRecord)">
                                                        <td class="membertable-name">{{ userRecord.name }}</td>
                                                        <td class="membertable-email">{{ userRecord.email }}</td>
                                                        <td>{{ getDateFormat(userRecord.created_at) }}</td>
                                                    </tr>
                                                </tbody></table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    
                                  </v-card-text>
                                </v-card>
                              </v-tab-item>
                            </v-tabs>
                        </v-container>
                    </v-card-text>
                    
                    <v-divider></v-divider>
                    
                    <v-card-actions class="justify-center grey lighten-4 pb-6">
                        <v-btn min-width="150px" class="white--text" color="red" large :disabled="invalid" @click="pushOk">
                            <slot name="ok-btn"></slot>
                        </v-btn>
                        <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false;">
                            <slot name="cancel-btn"></slot>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </validation-observer>
    </v-dialog>
</template>

<script>
  import { required, email, max } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
  import moment from 'moment';
  moment.locale('ja');

  extend('required', {
    ...required,
    message: '入力必須項目です',
  });

  extend('email', {
    ...email,
    message: '正しいメールアドレスをご入力ください',
  });

  extend('max', {
    ...max,
    message: '{length} 文字以内でご入力ください',
  });

export default {
    components: {
          ValidationProvider,
          ValidationObserver,
    },
    props: {
        sender: Object,
        currentSignerList: Array,
        currentIndex: Number,
        currentItem: Object,
        // ダイアログの開閉
        signerDialog: Boolean,
    },
    data() {
        return {
            item: null,
            destination_search_name: '',
            user_search_name: '',
            history_search_name: '',
            destinationUserRecords: [],
            userRecords: [],
            historyRecords:[],
            message: {
                success: false,
                text: '',
            },
            show1: false,
            localAccessCode: '',
            reRendorFlag: false
            
        };
    },
    // 初期表示のデータ
    async created () {
        this.item = {
            // id: '',
            id: this.currentItem.id?? '',
            destination_user_name: this.currentItem.destination_user_name?? '',
            destination_email_address: this.currentItem.destination_email_address?? '',
            destination_company_name: this.currentItem.destination_company_name?? '',
            access_code: this.currentItem.access_code?? '',
        };
        await this.initdestinationUserRecord();
        // 社員検索
        await this.initUserRecord();
        // 送信履歴
        await this.initHistoryRecord();
    },
    computed: {
        id: {
            get() {
                return this.item.id;
            },
        },
        destination_user_name: {
            get() {
                return this.item.destination_user_name;
            },
            set(value) {
                this.item.destination_user_name = value;
            }
        },
        destination_email_address: {
            get() {
                return this.item.destination_email_address;
            },
            set(value) {
                this.item.destination_email_address = value;
            }
        },
        destination_company_name: {
            get() {
                return this.item.destination_company_name;
            },
            set(value) {
                this.item.destination_company_name = value;
            }
        },
        filterDestinationRecords: function() { 
            let self = this;
            
            if (self.destination_search_name===null||self.destination_search_name==="") {
                return self.destinationUserRecords;
            }
            let destUserRecords = self.destinationUserRecords.filter(
                function (destinationUserRecordsFiltered) {       
                    return destinationUserRecordsFiltered.name.includes(self.destination_search_name) || destinationUserRecordsFiltered.company?.includes(self.destination_search_name) || destinationUserRecordsFiltered.email?.includes(self.destination_search_name);
                }
            );
            return destUserRecords;
        },
        filterUserRecords: function() { 
            let self = this;
            
            if (self.user_search_name===null||self.user_search_name==="") {
                return self.userRecords;
            }
            let userRecords = self.userRecords.filter(
                function (userRecordsFiltered) {       
                    return userRecordsFiltered.name.includes(self.user_search_name);
                }
            );
            return userRecords;
            
        },
        filterHistoryRecords: function() { 
            let self = this;
            
            if (self.history_search_name===null||self.history_search_name==="") {
                return self.historyRecords;
            }
            let historyRecords = self.historyRecords.filter(
                function (historyRecordsFiltered) {       
                    return historyRecordsFiltered.name.includes(self.history_search_name) || historyRecordsFiltered.company?.includes(self.history_search_name) || historyRecordsFiltered.email?.includes(self.history_search_name);
                }
            );
            return historyRecords;
        },
        // <!-- autocomplate対策 暫定 -->
        access_code: {
            get() {
                if (this.show1) {
                    return this.item.access_code?? '';
                } else {
                    let muskStr = '';
                    let str = this.item.access_code?? '';
                    for (let i = 0; i < str.length; i++)
                    {
                        muskStr += '•';
                    }
                    return muskStr;
                }
            },
            set(value) {
                if (!this.show1) {
                    if (value != null && value.length > 0 ){
                        if (value.length >= this.localAccessCode.length) {
                            let newStr = value.replace(/•/g, '');
                            let newStrIndex = value.indexOf(newStr);
                            if (value.length == this.localAccessCode.length) {
                                this.item.access_code = this.item.access_code.slice(0, newStrIndex) + newStr + this.item.access_code.slice(newStrIndex + 1);
                            } else {
                                this.item.access_code = this.item.access_code.slice(0, newStrIndex) + newStr + this.item.access_code.slice(newStrIndex);
                            }
                        } else {
                            let removeStrLength = value.length - this.localAccessCode.length;
                            this.item.access_code = this.item.access_code.slice(0, removeStrLength);
                        }
                        this.localAccessCode = '';
                        for (let i = 0; i < value.length; i++)
                        {
                            this.localAccessCode += '•';
                        }
                        
                        // 再描画 TODO : スマートな方法
                        const ele = this.$refs.accessCodeInput;
                        ele.text = this.localAccessCode;
                        this.reRendorFlag = true;
                        this.$nextTick(function() {
                            this.reRendorFlag = false;
                            setTimeout(() => {
                                const ele = this.$refs.accessCodeInput;
                                ele.$refs.input.focus();
                                ele.$refs.input.setSelectionRange(ele.$refs.input.value.length, ele.$refs.input.value.length);
                            });
                        });
                    } else {
                        this.localAccessCode = '';
                        this.item.access_code = '';
                    }
                } else {
                    this.item.access_code = value;
                    this.localAccessCode = '';
                    for (let i = 0; i < value.length; i++)
                    {
                        this.localAccessCode += '•';
                    }
                }
            }
        },
        handleDialog: {
            get() {
                return this.signerDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:signerDialog', value);
            }
        },
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            let self = this;
            this.$refs.observer.validate().then((result) => {
                if(result) {
                    let find = self.currentSignerList.find(item => item.destination_email_address == self.item.destination_email_address);
                    if (self.sender.destination_email_address== self.item.destination_email_address) {
                        self.message.text = "送信者のメールアドレスと重複しています";
                        self.message.success = false;
                        return false;
                    }
                    if (find != null && self.currentSignerList.indexOf(find) != self.currentIndex) {
                        self.message.text = "すでに宛先に設定されているメールアドレスです";
                        self.message.success = false;
                        return false;
                    }
                    self.item.has_access_code = self.item.access_code == '' ? true : false;
                    // 親コンポーネントへの通知
                    self.$emit("clickOk", self.item);
                    self.handleDialog = false;
                }
            });
        },
        // 契約先メンバー検索
        initdestinationUserRecord() {
            let self = this;
            window.axios.get('/documents/contract_destination_members')
            .then(response => {
                self.destinationUserRecords = response.data.records;
            });
            
        },
                
        // 社員検索
        initUserRecord() {
            let self = this;
            var result = window.axios.get('/documents/users-search', {
                params: {
                    name: self.user_search_name,
                }
            }).then(
                response => (
                    self.userRecords = response.data.userRecords
                )
            );
            
        },
        // 社員検索
        initHistoryRecord() {
            let self = this;
            var result = window.axios.get('/documents/sent-users', {
            }).then(
                response => (
                    self.historyRecords = response.data.records
                )
            );
            
        },
        // 選択行の反映
        async selected_reflect(destinationUserRecord) {
            this.item.destination_user_name = destinationUserRecord.name;
            this.item.destination_email_address = destinationUserRecord.email;
            this.item.destination_company_name = destinationUserRecord.company;
        },
        // 選択行の反映
        async selected_user_reflect(userRecord) {
            this.item.destination_user_name = userRecord.name;
            this.item.destination_email_address = userRecord.email;
            this.item.destination_company_name = userRecord.company;
        },
        getDateFormat(date) {
            if(date == null || date == '' || !date.trim()){
                return "";
            }
            if (moment().format('YYYY') == moment(date).format('YYYY')) {
                // 今年の場合は月日を表示
                return moment(date).format('M月D日');
            }else{
                return moment(date).format('YYYY/M/D');
            }
        },
    },
};
</script>

<style scoped>
    .v-tab:active {
        background-color: white !important;
    }
    .confirm-message {
        text-align: center;
    }
    .search-container {
        border: 1px solid #aaa;
        border-radius: 0,6px;
    }
    .searchbtn {
        width: 60px;
        height: 56px;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        border: 1px solid #aaa;
        margin-left: -3px;
        background-color: white;
        color: black;
    }
    
    .searchbtn:after {
        background-color: white;
    }
    .member-area {
        margin-top: -30px;
        overflow: auto;
        height: 350px;
    }
    .membertable {
        border-collapse: collapse;
        width: 620px;
    }
    .membertable-row {
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }
    .membertable-row:hover {
        cursor:pointer;
        background-color: #ddd;
        transition: all  0.3s ease;
    }
    .membertable-name {
        padding: 10px;
        width: 170px;
        font-weight: bold;
    }
    .membertable-email {
        width: 340px;
    }
    .membertable-company {
        display:none;
    }
    .display-flex {
        display: flex;
    }
    .destination-member-area {
        margin-top: -30px;
        overflow: auto;
        height: 350px;
    }
    .destination-member-table {
        border-collapse: collapse;
        width: inherit;
    }
    .destination-member-table tr {
        border-top: 1px solid #aaa;
        border-bottom: 1px solid #aaa;
    }
    .destination-member-table tr:hover {
        cursor:pointer;
        background-color: #ddd;
        transition: all 0.3s ease;
    }
    .destination-member-table td {
        padding: 10px;
    }
</style>